<script>
  import In from "@/components/atoms/In";
  import Btn from "@/components/atoms/Btn";
  import Banner from "@/components/atoms/Banner";
  import SaveFile from "@/components/atoms/SaveFile";
  import Loading from "@/components/atoms/Loading";
  export default {
    components: { In, Btn, Banner, SaveFile, Loading },
    computed: {
      saveFiles(){
        return this.$store.get('saveFiles/saveFiles')
      }
    },
    methods: {
      newProject(){
        this.$store.dispatch('postMessage', "NewProject:New");
      },
      downloadLink(){
        this.mixpanel.track('Download Link');
        window.open('https://www.oculus.com/experiences/quest/5547678341955089/', '_blank').focus()
      }
    }
  }
</script>

<template>
  <Banner>
    <div id="home-page">
      <div class="section">
        <Loading :loading="$store.get('saveFiles/loading')"/>
        <div class="welcome-module">
          <div class="welcome">
            Welcome to Quadrobee!
          </div>
          <div class="sub-header">
            Get started
          </div>
          <div class="big-buttons">
            <div class="button-container">
              <div v-if="$store.get('vr')" class="big-button new-project" @click="newProject">
                New Project
              </div>
              <div v-else class="big-button new-project" @click="downloadLink">
                Download
              </div>
            </div>
            <div class="button-container" v-if="!$store.get('usingMobile')">
              <div class="big-button tutorial" @click="() => $router.push('/tutorials')">
                Tutorials
              </div>
            </div>
          </div>
          <div class="sub-header">
            Build
          </div>
          <div class="list-button" @click="() => $router.push('/projects')">
            <i class="fas fa-warehouse-alt"></i> Projects
          </div>
          <div class="list-button" @click="() => $router.push('/templates')" v-if="!$store.get('usingMobile')">
            <i class="fas fa-drafting-compass"></i> Templates
          </div>
          <div class="list-button" @click="() => $router.push('/parts/categories')" v-if="!$store.get('usingMobile')">
            <i class="fas fa-boxes-alt"></i> Parts
          </div>
          <div class="sub-header">
            Account
          </div>
          <div class="list-button" @click="() => $router.push('/order-history')">
            <i class="fas fa-truck"></i> Orders
          </div>
          <div class="list-button" @click="() => $router.push('/settings')">
            <i class="fas fa-user-cog"></i> Settings
          </div>
          <div class="row">
            <div class="container">
              <div class="icon">
                <span class="fa fa-comments-alt"></span>
              </div>
              <div class="title">
                Community 
              </div>
              <div class="description">
                Ask questions and discuss topics <br>
                with other builders.
              </div>
              <div class="link">
                Reddit/r/Quadrobee
              </div>
            </div>
            <div class="container">
              <div class="icon">
                <span class="fa fa-user-headset"></span>
              </div>
              <div class="title">
                Support 
              </div>
              <div class="description">
                Get in touch with Quadrobee <br>
                support specialist.
              </div>
              <div class="link">
                Support@Quadrobee.com
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
#home-page { 
  min-height: 100vh;
	.section { 
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $black_1;
    padding: 5rem 0rem;
    &.footer{
      // background-color: $black_0;
    }
		.welcome-module { 
      padding: 0rem 2rem;
      flex-basis: 50rem;
			.welcome { 
        font-size: 2rem;
			}

			.sub-header { 
        font-size: 1.25rem;
        color: $w_1;
        padding: 3rem 0rem 0.75rem 0rem;
			}

			.big-buttons { 
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding-top: 0.5rem;
        margin: 0rem -0.5rem;
        .button-container{
          flex-grow: 1;

          height: 8rem;
          padding: 0.5rem 0.5rem;
          .big-button { 
            width: 100%;
            height: 100%;
            padding: 1rem 1.25rem;
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            justify-content: flex-start;
            font-size: 2rem;
            border-radius: 3px;
            box-shadow: $z_depth_2;
            transition: transform 0.2s ease;
            &:hover, .hover{
              cursor: pointer;
              transform: scale(1.025);
            }
            &.new-project{
              background: $p;
              background: linear-gradient(149deg, rgba(200,116,251,1) 0%, rgba(178,99,247,1) 46%, rgba(130,64,221,1) 100%);

            }
            &.tutorial{
              background: rgb(158,247,99);
              background: linear-gradient(149deg, rgba(158,247,99,1) 0%, rgba(50,179,175,1) 100%);
            }
          }
        }
			}

			.list-button { 
        font-size: 1.5rem;
        padding: 1rem 1.5rem;
        margin: 0 -1.5rem;
        border-radius: 3px;
        display: flex;
        align-items: center;
        &:hover, .hover{
          cursor: pointer;
          background-color: $black_3;
        }
        .fas{
          width: 24px;
          margin-right: 1.5rem;
          font-size: 1.5rem;
        }
			}
		}
    .row { 
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: stretch;
      margin-top: 5rem;
			.container { 
        flex-grow: 1;
        margin-bottom: 2rem;
				.icon { 
          margin-bottom: 1rem;
					.fa { 
            font-size: 2rem;
					}
				}

				.title { 
          font-size: 1.5rem;
          margin-bottom: 1rem;
				}

				.description { 
          font-size: 1.125rem;
          margin-bottom: 1rem;
				}

				.link { 
          font-size: 1.25rem;
          color: $p;
				}
			}
		}
	}
}
</style>